// extracted by mini-css-extract-plugin
module.exports = {"avatar":"Avatar_avatar__dCV5L"};